import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { menuItems } from './home.config';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  readonly isAdmin = this.auth.hasRoles(['Admin']);
  constructor(
    private router: Router,
    private authService: AuthService,
    private auth: AuthService,
    // ...existing code...
  ) { }

  token$ = this.authService.token$;

  loadingCompany = true;

  onButtonClick(item: any) {
    this.router.navigate([item.routerLink]);
  }

  isTileButtonVisible(item: any): boolean {
    // If no roles or permissions are specified, item is visible
    if ((!item.roles || item.roles.length === 0) && (!item.permissions || item.permissions.length === 0)) {
      return true;
    }

    // Check roles if specified - if user has one of the roles, show the item
    if (item.roles && item.roles.length > 0) {
      if (this.authService.hasRoles(item.roles)) {
        return true;
      }
    }

    // Check permissions if specified - if user has one of the permissions, show the item
    if (item.permissions && item.permissions.length > 0) {
      const token = this.authService.token$.getValue();
      if (!token) return false;

      // Parse permissions - handle both string (JSON) and array formats
      let userPermissions: string[] = [];
      const permissionsValue = (token as any).permissions;
      if (permissionsValue) {
        if (typeof permissionsValue === 'string') {
          try {
            userPermissions = JSON.parse(permissionsValue);
          } catch (e) {
            console.warn('Failed to parse permissions from token', e);
          }
        } else if (Array.isArray(permissionsValue)) {
          userPermissions = permissionsValue;
        }
      }

      if (userPermissions.length > 0) {
        if (item.permissions.some((permission: string) => userPermissions.includes(permission))) {
          return true;
        }
      } else {
        // Fallback: check functionalities if permissions not available
        let userFunctionalities: string[] = [];
        const functionalitiesValue = (token as any).functionalities;
        if (functionalitiesValue) {
          if (typeof functionalitiesValue === 'string') {
            try {
              userFunctionalities = JSON.parse(functionalitiesValue);
            } catch (e) {
              console.warn('Failed to parse functionalities from token', e);
            }
          } else if (Array.isArray(functionalitiesValue)) {
            userFunctionalities = functionalitiesValue;
          }
        }

        if (userFunctionalities.length > 0) {
          // Map functionalities to permissions for comparison
          const functionalityToPermissionMap: { [key: string]: string[] } = {
            'PRESCRIPTION_VERIFY': ['PRESCRIPTIONS_VIEW', 'OTP_REQUEST', 'OTP_VALIDATE', 'DOCUMENTS_UPLOAD', 'CONTACT', 'SETTINGS_UPDATE'],
            'PHARMACY_MANAGE': ['USER_MANAGEMENT'],
            'ADMIN_VIEW': ['ADMIN_VIEW', 'ROLE_MANAGEMENT', 'users']
          };

          const mappedPermissions: string[] = [];
          userFunctionalities.forEach((func: string) => {
            const mapped = functionalityToPermissionMap[func.toUpperCase()] || [];
            mappedPermissions.push(...mapped);
          });

          if (item.permissions.some((permission: string) => mappedPermissions.includes(permission))) {
            return true;
          }
        }
      }
    }

    // If we have roles or permissions specified but none match, hide the item
    return false;
  }

  getMenuItems() {
    return menuItems;
  }

}
